import "./deletecandidatemodal.scss";
import cross from "images/cross.svg";
import { Modal } from "react-bootstrap";
import { inject, observer } from "mobx-react";

const DeleteCandidateModal = ({
  deleteCandidate,
  setDeleteCandidateModal,
  deleteMessage,
  setDeleteModalMessage,

  setSelectedCandidate,
  cleanErrorAddition,
  clearOneCandidate,
  getCandidates,

  sendingFunc,
  setFunc,

  ...props
}) => {
  return (
    <Modal show={props.show} onHide={props.onHide} size="md" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static">
      <Modal.Body className="deletecandidate-wrapper">
        <p>
          <img
            src={cross}
            className="signin-img"
            onClick={() => {
              setDeleteModalMessage("");
              setDeleteCandidateModal(false);
            }}
            alt=""
          />
        </p>
        <div className="deletecandidate">
          <p className="deletecandidate-title">
            {deleteMessage}
          </p>
          <div className="deletecandidate-btns">
            <button
              type="submit"
              className="deletecandidate-leftbtn"
              onClick={() => {
                setDeleteCandidateModal(false);
              }}
            >
              Нет
            </button>
            <button
              type="submit"
              className="deletecandidate-rightbtn"
              onClick={() => {
                deleteMessage.charAt(0).match(/в/i) && deleteCandidate();
                setDeleteCandidateModal(false);
                props.setIsCandidateModalOpen(false);
                setDeleteModalMessage("");
                setSelectedCandidate("");
                cleanErrorAddition();
                clearOneCandidate();

                if (sendingFunc) {
                  sendingFunc();
                  setFunc(null);
                }
                getCandidates();
              }}
            >
              Да
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ modalWindows, candidatesStore }) => {
  const { setIsCandidateModalOpen, isCandidateModalOpen, setDeleteCandidateModal, deleteMessage, setDeleteModalMessage, sendingFunc, setFunc } = modalWindows;

  const { deleteCandidate, isNewCandidate, selectedCandidate, setSelectedCandidate, cleanErrorAddition, clearOneCandidate, getCandidates } = candidatesStore;

  return {
    setIsCandidateModalOpen,
    isCandidateModalOpen,
    deleteCandidate,
    candidatesStore,
    isNewCandidate,
    selectedCandidate,
    setDeleteCandidateModal,
    deleteMessage,
    setDeleteModalMessage,

    setSelectedCandidate,
    cleanErrorAddition,
    clearOneCandidate,
    getCandidates,

    sendingFunc,
    setFunc
  };
})(observer(DeleteCandidateModal));